(() => {
  const init = () => {
    document.querySelectorAll('[data-menu-toggle]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      if (!menu) return;
      const close = () => { menu.hidden = true; button.setAttribute('aria-expanded', 'false'); };
      button.addEventListener('click', () => {
        const opening = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(opening));
        menu.hidden = !opening;
      });
      menu.addEventListener('click', event => { if (event.target.closest('a')) close(); });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !menu.hidden) { close(); button.focus(); }
      });
      window.matchMedia('(min-width: 900px)').addEventListener('change', event => { if (event.matches) close(); });
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
